import { connect } from 'react-redux';
import MonthlykWhInputs from './MonthlykWhInputs';

import { setMonthlyKWHInputs } from '../../../common/utility/actions';

const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    monthlyKWh: state.utility.monthlyKWh,
    setMonthlyKWHInputs,
});

const combinedActions = {
    setMonthlyKWHInputs,
};

export default connect(
    mapStateToProps,
    combinedActions,
)(MonthlykWhInputs);



// WEBPACK FOOTER //
// ./src/containers/Inputs/UtilityInputs/MonthlykWhInputs/index.js